export interface EngineGuestDataEntity {
  id: string;
  bookingFormCountry: boolean;
  bookingFormPhone: boolean;
  bookingFormDni: boolean;
  bookingFormAddress: boolean;
  bookingFormCity: boolean;
  bookingFormPostalCode: boolean;
  bookingFormRepeatEmail: boolean;
  bookingFormArrivalTime: boolean;
  bookingFormNewsletter: boolean;
  bookingFormBirthDate: boolean;
  bookingFormAllGuestsData: boolean;
}

export type StringBoolean = "1" | "0";
export const StringBooleanMapping: Record<string, StringBoolean> = { true: "1", false: "0" };

export interface EngineGuestDataDto {
  esDatosReservaPais: StringBoolean;
  esDatosReservaTelefono: StringBoolean;
  esDatosReservaDni: StringBoolean;
  esDatosReservaDireccion: StringBoolean;
  esDatosReservaEmailRepeat: StringBoolean;
  esDatosReservaCiudad: StringBoolean;
  esDatosReservaCodigoPostal: StringBoolean;
  require_arrival_time: StringBoolean;
  esDatosReservaPeticionOferta: StringBoolean;
  esDatosReservaFechaNacimiento: StringBoolean;
  esDatosReservaParticipantes: StringBoolean;
}
